"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  url: 'https://cdn.prod.us.five9.net/static/stable/chat/wrapper/index.js'
};
exports.default = _default;
